import { Vector4 } from "three";
import ConservationScore from "../../../../models/ConservationScore";
import { getScoresRectMesh, drawScores } from "./conervationBlueprint";
import { CONSERVATION_CL } from "../../constants/options";
import ColorScale from "../../models/ColorScale";

function getDefaultState() {
  return { scores: [], config: {}, minY: 1, maxY: -1 };
}

function conservationTrackController(track) {
  let state = getDefaultState();

  const rectMesh = getScoresRectMesh();

  function onRangeChange({ chrSegments }) {
    track.loadPosition(chrSegments);
  }

  function onReset() {
    state = getDefaultState();
  }

  function onPreferencesChanged() {
    const config = track.getPreferences();
    state.config = config;
    const { isDark } = config;
    const scaleName = config[CONSERVATION_CL];
    const theme = isDark ? 2 : 1;

    const rgbVecs = new ColorScale(scaleName, 5).setTheme(theme).vectors;
    const vecs = [...rgbVecs, new Vector4(0.5, 0.5, 0.5, 1), new Vector4()];
    rectMesh.uniforms.setColorMap(vecs);
    track.requestRender();
  }

  function calcRange(scores) {
    for (let i = 0; i < scores.length; i++) {
      if (scores[i].phylopScore > state.minY) {
        state.minY = scores[i].phylopScore;
      }
      if (scores[i].phylopScore < state.maxY) {
        state.maxY = scores[i].phylopScore;
      }
    }
  }

  function onDataReceived({ chr, res, x0 }) {
    const plylop100 = res?.phylop100way?.conservation_score || [];
    const scores = plylop100
      .map((x, i) => [x, i + x0, chr])
      .map((x) => new ConservationScore(...x));

    calcRange(scores);

    rectMesh.uniforms.setMinY(state.minY).setMaxY(state.maxY);

    state.scores = state.scores.concat(scores);
    rectMesh.setItems(state.scores);

    drawScores(scores, rectMesh);
    track.requestRender();
  }

  return {
    onReset,
    onRangeChange,
    onDataReceived,
    onPreferencesChanged,
    meshes: [rectMesh],
  };
}

export default conservationTrackController;
